import React from 'react';
import styles from '../../command-palette.scss';

export const CommandPaletteNoResults = () => {
  return (
    <div className={styles.commandPaletteSection}>
      <div className={styles.commandPaletteSectionHeader}>
        <span className={styles.sectionTitle}>No results found</span>
      </div>
    </div>
  );
};
